import type { ReturnLocation } from './index.h'

import { createEvent, createStore, sample } from 'effector'
import { model as router } from '~/core/router'
import { PROFILES } from '~/shared/routes'

export const rememberManageReturnLocation = createEvent<ReturnLocation>()
export const rememberManageReturnLocationFromPrevious = createEvent<void>()
export const rememberManageReturnLocationFromLocation = createEvent<{
  pathname: string
}>()

export const $manageReturnLocation = createStore<ReturnLocation | null>(
  null
).on(rememberManageReturnLocation, (_, location) => location)

sample({
  clock: rememberManageReturnLocationFromPrevious,
  source: router.$previous,
  filter: (previous) =>
    Boolean(previous?.pathname) && !PROFILES.isManage(previous!.pathname),
  fn: (previous) => ({
    pathname: previous!.pathname,
    search: previous!.search,
    hash: previous!.hash,
  }),
  target: rememberManageReturnLocation,
})

sample({
  clock: rememberManageReturnLocationFromLocation,
  filter: ({ pathname }) => /~/.test(pathname),
  fn: ({ pathname }) => {
    const matched = pathname.match(/~(.*)$/)
    const tail = matched?.[1] ? matched[1] : ''
    const normalizedTail = tail.startsWith('/') ? tail : `/${tail}`
    return { pathname: normalizedTail }
  },
  target: rememberManageReturnLocation,
})
